import React from 'react';
import './GuessForm.css';
import Keyboard from './Keyboard';

interface GuessFormProps {
  onGuessLetter: (letter: string) => void;
  gameOver: boolean;
  wordLength: number;
  secretWord?: string; 
  letterGuessesLeft?: number;
  guessedLetters: string[];
  autoRevealedLetters: string[];
  dailyChallengeCompleted?: boolean;
}

function GuessForm({ 
  onGuessLetter, 
  gameOver, 
  wordLength,
  secretWord = '',
  letterGuessesLeft = 0,
  guessedLetters,
  autoRevealedLetters,
  dailyChallengeCompleted = false
}: GuessFormProps) {
  // Check if letter guesses are exhausted
  const noLetterGuessesLeft = letterGuessesLeft <= 0;

  return (
    <div className="guess-form">
      <div className="keyboard-section">
        <Keyboard 
          onLetterClick={onGuessLetter}
          guessedLetters={guessedLetters}
          secretWord={secretWord}
          gameOver={gameOver || noLetterGuessesLeft || dailyChallengeCompleted}
        />
      </div>
    </div>
  );
}

export default GuessForm;
